import React from 'react'
import Icon from '@ant-design/icons'
import {AntdIconProps} from '@ant-design/icons/es/components/AntdIcon'

const ProductRoadMapSVG = () => {
  return (
    <svg
      id='prefix__Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      x='0'
      y='0'
      viewBox='0 0 275 200'
      xmlSpace='preserve'
      width='50px'
      height='50px'
    >
      <style>{'.prefix__st0{fill:#bac5d4}'}</style>
      <path
        className='prefix__st0'
        d='M101.41,37.05c-1.95,2.14-4.22,4.05-6.77,5.6c-0.31,0.23-0.74,0.26-1.09,0.03c-3.76-2.39-6.93-5.27-9.41-8.4
        c-3.43-4.3-5.59-9.07-6.33-13.66c-0.75-4.66-0.05-9.14,2.27-12.79C81,6.4,82.17,5.08,83.59,3.95c3.27-2.6,7-3.98,
        10.73-3.95 c3.58,0.03,7.12,1.36,10.18,4.15c1.08,0.98,1.98,2.09,2.72,3.31c2.49,4.11,3.03,9.34,1.93,14.65 C108.07,
        27.36,105.39,32.69,101.41,37.05L101.41,37.05L101.41,37.05z M23.88,92.06c-1.95,2.14-4.22,4.05-6.77,5.6 c-0.31,
        0.23-0.74,0.26-1.09,0.03c-3.76-2.4-6.93-5.27-9.41-8.4C3.19,85,1.03,80.23,0.29,75.63c-0.75-4.66-0.05-9.14,
        2.27-12.78 c0.91-1.44,2.08-2.75,3.51-3.88c3.27-2.6,7-3.98,10.72-3.95c3.58,0.03,7.12,1.36,10.18,4.15c1.08,0.98,
        1.98,2.09,2.72,3.31 c2.49,4.11,3.03,9.34,1.93,14.65C30.54,82.37,27.86,87.7,23.88,92.06L23.88,92.06L23.88,
        92.06z M17.07,103.04 c4.51,0,8.32,3.02,9.52,7.14h59.97c2.96,0,5.66-1.21,7.62-3.17c1.96-1.96,3.17-4.65,3.17-7.62l0,
        0c0-2.96-1.21-5.66-3.17-7.62 c-1.96-1.96-4.65-3.17-7.62-3.17H65.58v0c-4.71,0-8.99-1.92-12.09-5.02c-3.1-3.1-5.02-7.38-5.02-12.09l0,
        0 c0-4.71,1.92-8.99,5.02-12.09c3.1-3.1,7.38-5.02,12.09-5.02h18.97c1.3-3.96,5.03-6.82,9.42-6.82c5.48,0,9.92,4.44,
        9.92,9.92 c0,5.48-4.44,9.92-9.92,9.92c-4.35,0-8.04-2.8-9.38-6.69H65.58c-2.96,0-5.66,1.21-7.62,3.17c-1.96,1.96-3.17,
        4.65-3.17,7.62l0,0 c0,2.96,1.21,5.66,3.17,7.62c1.94,1.94,4.61,3.15,7.55,3.17v0h21.06c4.71,0,8.99,1.92,12.09,5.02c3.1,
        3.1,5.02,7.38,5.02,12.09l0,0 c0,4.71-1.92,8.99-5.02,12.09c-3.1,3.1-7.38,5.02-12.09,5.02H26.34c-1.43,3.73-5.04,6.37-9.27,
        6.37c-5.48,0-9.92-4.44-9.92-9.92 C7.15,107.48,11.59,103.04,17.07,103.04L17.07,103.04z M16.08,63.3c4.42,0,8,3.58,8,8c0,
        4.42-3.58,8-8,8c-4.42,0-8-3.58-8-8 C8.08,66.88,11.66,63.3,16.08,63.3L16.08,63.3z M93.61,8.28c4.42,0,8,3.58,8,8c0,4.42-3.58,
        8-8,8c-4.42,0-8-3.58-8-8 C85.61,11.86,89.19,8.28,93.61,8.28L93.61,8.28z'
      />
    </svg>
  )
}

export const ProductRoadMapIcon = (props: AntdIconProps) => (
  <Icon component={ProductRoadMapSVG} {...(props as any)} />
)
